/* eslint-disable */

import * as $ from "jquery";

interface Player {
    color?: number;
    alive?: boolean;
    cards?: number;
    territories?: number;
    troops?: number;
    reinforcements?: number;
}

interface GameState {
    territories: {
        [territoryId: string]: {
            territory_id: number,
            player_id: number,
            troops: number
        }
    };
    players:{[playerIdx: number]: Player};
    round?: number;
}

interface GameStateChange {
    territories?: {
        before: {
            [territoryId: string]: {
                territory_id: number,
                player_id: number,
                troops: number
            }
        },
        after: {
            [territoryId: string]: {
                territory_id: number,
                player_id: number,
                troops: number
            }
        },
    };
    players?: {
        before: {
            [playerIdx: number]: Player
        },
        after: {
            [playerIdx: number]: Player
        }
    };
    round?: {before: number, after: number};
    isNotPlaybackBlocking: boolean;
}

interface GameEvent {
    game_event_id: number;
    created_at: string;
    game_id: number;
    player_id: number;
    type: number;
    param1: number;
    param2: number | null;
    param3: number | null;
    param4: number | null;
    stateChange?: GameStateChange;
}

export class Playback {
    public currentStep: number;
    public playIntervalVariable: any;

    static createGameStateFromJsonObjects(
        jsonGameState: {[k: string]: any},
        colorList: number[]): GameState
    {
        let playersDict: {[playerIdx: number]: Player} = {};
        for (let stringIdx in jsonGameState.players) {
            let integerIdx: number = parseInt(stringIdx);
            let player: Player = {
                color: colorList[integerIdx - 1],
                alive: jsonGameState.players[stringIdx].alive,
                cards: jsonGameState.players[stringIdx].cards,
                territories: jsonGameState.players[stringIdx].territories,
                troops: jsonGameState.players[stringIdx].troops,
                reinforcements: jsonGameState.players[stringIdx].reinforcements,
            };
            playersDict[integerIdx] = player;
        }
        let gameState: GameState = {
            territories: jsonGameState.territories,
            players: playersDict
        };
        return gameState;
    }

    public constructor(
        public gameState: GameState,
        public eventList: GameEvent[]
    ) {
        this.currentStep = 0;
        this.playIntervalVariable = null;
        this.createInterfaceModal();
        this.initializeEventsAndState(this.gameState, this.eventList);
        this.createPlaybackEvents(this.gameState, this.eventList);
        this.bindPlaybackButtons();
    }

    private createInterfaceModal() {
        let container = $('#modal-container');
        container.append('<div id="playback-interface-modal" class="modal"></div>');
        let modal = $("#playback-interface-modal");
        modal.append('<i id="playback-first-button" class="fa fa-fast-backward fa-2x fa-fw "></i>');
        modal.append('<i id="playback-prevround-button" class="fa fa-backward fa-2x fa-fw "></i>');
        modal.append('<i id="playback-backward-button" class="fa fa-step-backward fa-2x fa-fw "></i>');
        modal.append('<i id="playback-play-pause-button" class="fa fa-play fa-2x fa-fw "></i>');
        modal.append('<i id="playback-forward-button" class="fa fa-step-forward fa-2x fa-fw "></i>');
        modal.append('<i id="playback-nextround-button" class="fa fa-forward fa-2x fa-fw "></i>');
        modal.append('<i id="playback-last-button" class="fa fa-fast-forward fa-2x fa-fw "></i>');
        modal.offset({
            top: 0.3 * ($(window).height() - modal.height()) + $(window).scrollTop(),
            left: 0.5 * ($(window).width() - modal.width()) + $(window).scrollLeft()
        });
        modal.mousedown(function(e) {
            let initialX = e.pageX;
            let initialY = e.pageY;
            let initialOffset = $('#playback-interface-modal').offset();
            let elem = $('#playback-interface-modal');
            let onMouseUp = function() {
                $('body')
                    .off('mouseup', onMouseUp)
                    .off('mousemove', onMouseMove)
                    .css('cursor', 'auto');
            };
            let onMouseMove = function(e: any) {
                $(elem).offset({
                    left: initialOffset.left + e.pageX - initialX,
                    top: initialOffset.top + e.pageY - initialY
                });
                return false; // Prevents selection
            };
            return $('body')
                .on('mouseup', onMouseUp)
                .on('mousemove', onMouseMove)
                .css('cursor', "move");
        });
        modal.find('i').mousedown(function(e) { e.stopImmediatePropagation(); });
    }

    private bindPlaybackButtons() {
        $('#playback-first-button').on("click", () => this.driveToFirstState());
        $('#playback-prevround-button').on("click", () => this.driveToPreviousRound());
        $('#playback-backward-button').on("click", () => this.driveBackward());
        $('#playback-play-pause-button').on("click", () => this.togglePlayPause());
        $('#playback-forward-button').on("click", () => this.driveForward());
        $('#playback-nextround-button').on("click", () => this.driveToNextRound());
        $('#playback-last-button').on("click", () => this.driveToLastState());
    }

    private initializeEventsAndState(state: GameState, eventList: GameEvent[]) {
        let neutral: Player = {
            color: 0,
            alive: false,
            cards: 0,
            territories: undefined,
            troops: undefined,
            reinforcements: 0,
        }
        state.players[0] = neutral;
        state.round = 1;
        // split each conquer event into equivalent separate conquer and move troops event
        for (let idx = eventList.length - 1; idx >=0; idx--) {
            if (eventList[idx].type == 5) { // if event is a conquer event:
                let moveEvent: GameEvent = $.extend(true, {}, eventList[idx]);
                moveEvent.param3 = eventList[idx].param4;
                moveEvent.param4 = null;
                moveEvent.type = 6; // troops.move
                eventList[idx].param4 = 0;
                eventList.splice(1 + idx, 0, moveEvent);
            }
        }
    }

    private createPlaybackEvents(initialState: GameState, eventList: GameEvent[]) {
        let gameState = $.extend(true, {}, initialState);
        for (let event of eventList) {
            event.stateChange = this.computeStateChangeForEvent(gameState, event);
            this.applyStateChange(gameState, event.stateChange);
        }
    }

    private computeStateChangeForEvent(gameState: GameState, gameEvent: GameEvent): GameStateChange {
        switch (gameEvent.type) {
            case 0: // round param1 started
                if (gameEvent.param1 - 1 != gameState.round) {
                    throw new Error("state is inconsistent with event");
                }
                let stateChange: GameStateChange = {
                    round: {after: gameEvent.param1, before: gameEvent.param1 - 1},
                    isNotPlaybackBlocking: true
                };
                return stateChange;

            case 1: // receive param1 troops cumulatively for territories/regions
                // no playback event
                break;

            case 2: // receive X troops for turning in param1, param2, param3. param4 is next card bonus!
                return this.computeStateChangeForTurningCardsIn(gameState, gameEvent);

            case 3:
                return this.computeStateChangeForReinforcement(gameState, gameEvent);

            case 4:
                return this.computeStateChangeForAttack(gameState, gameEvent);

            case 5:
                if (gameEvent.param4 !== 0) {
                    throw new Error("it seems conquer event is not split into conquer and move events");
                }
                return this.computeStateChangeForConquer(gameState, gameEvent);

            case 6:
                return this.computeStateChangeForMoveTroops(gameState, gameEvent);

            case 7: // receive card for territory param1 in color param2 of deck param4 with param3 troops
                // no playback event
                break;

            case 8: // commented out
                // no playback event
                break;

            case 9: // turn neutral
                return this.computeStateChangeForTurningNeutral(gameState, gameEvent);

            case 10:
                return this.computeStateChangeForDecay(gameState, gameEvent);

            case 11: // an additional param1 troops were moved after conquering
                alert("No playback event implemented for moving additional troop after conquer");
                throw new Error("No playback event implemented for moving additional troop after conquer");

            case 12: // change your target manually to your target\'s target
                // no playback event
                break;

            default:
                throw new Error("Event type should be in [0-12]");
        }
        // state change is empty if not returned yet
        const stateChange: GameStateChange = {isNotPlaybackBlocking: true};
        return stateChange;
    }

    computeStateChangeForTurningCardsIn(gameState: GameState, gameEvent: GameEvent): GameStateChange {
        let stateChange: GameStateChange = {
            territories: {before: {}, after: {}},
            players: {before: {}, after: {}},
            isNotPlaybackBlocking: false
        };
        let playerIdx: number = gameEvent.player_id;
        let bonusTroops: number = 0;
        let territoryIds: number[] = [
            (gameEvent.param1 >> 2),
            (gameEvent.param2 >> 2),
            (gameEvent.param3 >> 2)
        ];
        for (const territoryId of territoryIds) {
            if (gameState.territories[territoryId.toString()].player_id === playerIdx) {
                stateChange.territories.before[territoryId.toString()] = {
                    territory_id: territoryId,
                    player_id: playerIdx,
                    troops: gameState.territories[territoryId.toString()].troops
                };
                stateChange.territories.after[territoryId.toString()] = {
                    territory_id: territoryId,
                    player_id: playerIdx,
                    troops: gameState.territories[territoryId.toString()].troops + 2
                };
                bonusTroops += 2;
            }
        }
        stateChange.players.before[playerIdx] = {troops: gameState.players[playerIdx].troops};
        stateChange.players.after[playerIdx] = {troops: gameState.players[playerIdx].troops  + bonusTroops};
        return stateChange;
    }

    // event description: territory param1 is reinforced with param2 troops
    public computeStateChangeForReinforcement(gameState: GameState, gameEvent: GameEvent): GameStateChange {
        const stateChange: GameStateChange = {
            territories: {before: {}, after: {}},
            players: {before: {}, after: {}},
            isNotPlaybackBlocking: false
        };
        const playerIdx: number = gameEvent.player_id;
        const territoryId: string = gameEvent.param1.toString();

        stateChange.territories.before[territoryId] = {
            territory_id: gameEvent.param1,
            player_id: gameEvent.player_id,
            troops: gameState.territories[territoryId].troops
        };
        stateChange.territories.after[territoryId] = {
            territory_id: gameEvent.param1,
            player_id: gameEvent.player_id,
            troops: gameState.territories[territoryId].troops + gameEvent.param2
        };
        stateChange.players.before[playerIdx] = {troops: gameState.players[playerIdx].troops};
        stateChange.players.after[playerIdx] = {troops: gameState.players[playerIdx].troops  + gameEvent.param2};
        return stateChange;
    }

    // event description: territory param1 attacks territory param2, killing param3, losing param4
    public computeStateChangeForAttack(gameState: GameState, gameEvent: GameEvent): GameStateChange {
        const stateChange: GameStateChange = {
            territories: {before: {}, after: {}},
            players: {before: {}, after: {}},
            isNotPlaybackBlocking: false
        };
        const attackerIdx: number = gameEvent.player_id;
        const territoryFrom: string = gameEvent.param1.toString();
        const territoryTo: string = gameEvent.param2.toString();
        const defenderIdx: number = gameState.territories[territoryTo].player_id;

        stateChange.territories.before[territoryFrom] = {
            territory_id: gameEvent.param1,
            player_id: gameEvent.player_id,
            troops: gameState.territories[territoryFrom].troops
        };
        stateChange.territories.after[territoryFrom] = {
            territory_id: gameEvent.param1,
            player_id: gameEvent.player_id,
            troops: gameState.territories[territoryFrom].troops - gameEvent.param4
        };
        stateChange.territories.before[territoryTo] = {
            territory_id: gameEvent.param2,
            player_id: gameState.territories[territoryTo].player_id,
            troops: gameState.territories[territoryTo].troops
        };
        stateChange.territories.after[territoryTo] = {
            territory_id: gameEvent.param2,
            player_id: gameState.territories[territoryTo].player_id,
            troops: gameState.territories[territoryTo].troops - gameEvent.param3
        };
        stateChange.players.before[attackerIdx] = {troops: gameState.players[attackerIdx].troops};
        stateChange.players.after[attackerIdx] = {troops: gameState.players[attackerIdx].troops  - gameEvent.param4};
        if (defenderIdx != 0) {
            stateChange.players.before[defenderIdx] = {troops: gameState.players[defenderIdx].troops};
            stateChange.players.after[defenderIdx] = {troops: gameState.players[defenderIdx].troops  - gameEvent.param3};
        }
        return stateChange;
    }

    // event description: territory param1 conquers territory param2, killing [all], losing param3, moving param4
    public computeStateChangeForConquer(gameState: GameState, gameEvent: GameEvent): GameStateChange {
        const stateChange: GameStateChange = {
            territories: {before: {}, after: {}},
            players: {before: {}, after: {}},
            isNotPlaybackBlocking: false
        };
        const attackerIdx: number = gameEvent.player_id;
        const territoryFrom: string = gameEvent.param1.toString();
        const territoryTo: string = gameEvent.param2.toString();
        const defenderIdx: number = gameState.territories[territoryTo].player_id;

        stateChange.territories.before[territoryFrom] = {
            territory_id: gameEvent.param1,
            player_id: gameEvent.player_id,
            troops: gameState.territories[territoryFrom].troops
        };
        stateChange.territories.after[territoryFrom] = {
            territory_id: gameEvent.param1,
            player_id: gameEvent.player_id,
            troops: gameState.territories[territoryFrom].troops - gameEvent.param3
        };
        stateChange.territories.before[territoryTo] = {
            territory_id: gameEvent.param2,
            player_id: gameState.territories[territoryTo].player_id,
            troops: gameState.territories[territoryTo].troops
        };
        stateChange.territories.after[territoryTo] = {
            territory_id: gameEvent.param2,
            player_id: gameEvent.player_id,
            troops: 0
        };
        stateChange.players.before[attackerIdx] = {troops: gameState.players[attackerIdx].troops};
        stateChange.players.after[attackerIdx] = {troops: gameState.players[attackerIdx].troops  - gameEvent.param3};
        if (defenderIdx != 0) {
            stateChange.players.before[defenderIdx] = {troops: gameState.players[defenderIdx].troops};
            stateChange.players.after[defenderIdx] = {troops: gameState.players[defenderIdx].troops  - gameState.territories[territoryTo].troops};
        }
        return stateChange;
    }

    // event description: move param3 troops from territory param1 to territory param2
    public computeStateChangeForMoveTroops(gameState: GameState, gameEvent: GameEvent): GameStateChange {
        const stateChange: GameStateChange = {
            territories: {before: {}, after: {}},
            isNotPlaybackBlocking: false
        };
        const territoryFrom: string = gameEvent.param1.toString();
        const territoryTo: string = gameEvent.param2.toString();

        stateChange.territories.before[territoryFrom] = {
            territory_id: gameEvent.param1,
            player_id: gameEvent.player_id,
            troops: gameState.territories[territoryFrom].troops
        };
        stateChange.territories.after[territoryFrom] = {
            territory_id: gameEvent.param1,
            player_id: gameEvent.player_id,
            troops: gameState.territories[territoryFrom].troops - gameEvent.param3
        };
        stateChange.territories.before[territoryTo] = {
            territory_id: gameEvent.param1,
            player_id: gameEvent.player_id,
            troops: gameState.territories[territoryTo].troops
        };
        stateChange.territories.after[territoryTo] = {
            territory_id: gameEvent.param1,
            player_id: gameEvent.player_id,
            troops: gameState.territories[territoryTo].troops + gameEvent.param3
        };
        return stateChange;
    }

    public computeStateChangeForTurningNeutral(gameState: GameState, gameEvent: GameEvent): GameStateChange {
        let stateChange: GameStateChange = {
            territories: {before: {}, after: {}},
            players: {before: {}, after: {}},
            isNotPlaybackBlocking: false
        };
        let playerIdx: number = gameEvent.player_id;

        stateChange.players.before[playerIdx] = $.extend(true, {}, gameState.players[playerIdx]);
        stateChange.players.after[playerIdx] = $.extend(true, {}, gameState.players[playerIdx]);
        for (const territory in gameState.territories) {
            if (gameState.territories[territory].player_id == gameEvent.player_id) {
                stateChange.territories.before[territory] = {
                    territory_id: parseInt(territory),
                    player_id: gameEvent.player_id,
                    troops: gameState.territories[territory].troops
                };
                stateChange.territories.after[territory] = {
                    territory_id: parseInt(territory),
                    player_id: 0,
                    troops: gameState.territories[territory].troops
                };
                stateChange.players.after[playerIdx].troops -= gameState.territories[territory].troops;
                stateChange.players.after[playerIdx].territories -= 1;
            }
        }
        stateChange.players.after[playerIdx].alive = false;
        stateChange.players.after[playerIdx].cards = 0;
        stateChange.players.after[playerIdx].reinforcements = 0;
        return stateChange;
    }

    // event description: territory param1 loses param2 troops because of decay
    public computeStateChangeForDecay(gameState: GameState, gameEvent: GameEvent): GameStateChange {
        const stateChange: GameStateChange = {
            territories: {before: {}, after: {}},
            isNotPlaybackBlocking: false
        };
        const territoryIdx: string = gameEvent.param1.toString();

        stateChange.territories.before[territoryIdx] = {
            territory_id: gameEvent.param1,
            player_id: 0,
            troops: gameState.territories[territoryIdx].troops
        };
        stateChange.territories.after[territoryIdx] = {
            territory_id: gameEvent.param1,
            player_id: 0,
            troops: gameState.territories[territoryIdx].troops - gameEvent.param2
        };
        return stateChange;
    }

    public applyStateChange(gameState: GameState, stateChange: GameStateChange) {
        if (stateChange.round) {
            gameState.round = stateChange.round.after;
        }
        if (stateChange.territories) {
            $.extend(true, gameState.territories, stateChange.territories.after);
        }
        if (stateChange.players) {
            $.extend(true, gameState.players, stateChange.players.after);
        }
    }

    public unapplyStateChange(gameState: GameState, stateChange: GameStateChange) {
        if (stateChange.round) {
            gameState.round = stateChange.round.before;
        }
        if (stateChange.territories) {
            $.extend(true, gameState.territories, stateChange.territories.before);
        }
        if (stateChange.players) {
            $.extend(true, gameState.players, stateChange.players.before);
        }
    }

    public applyStateChangeOnView(stateChange: GameStateChange) {
        if (stateChange.territories) {
            for (let territoryIdx in stateChange.territories.after) {
                const newTroops = stateChange.territories.after[territoryIdx].troops;
                this.changeTerritoryTroops(territoryIdx, newTroops);
                const playerId = stateChange.territories.after[territoryIdx].player_id;
                const newColor = this.gameState.players[playerId].color;
                this.changeTerritoryColor(territoryIdx, newColor);
            }
        }
    }

    public unapplyStateChangeOnView(stateChange: GameStateChange) {
        if (stateChange.territories) {
            for (let territoryIdx in stateChange.territories.before) {
                const newTroops = stateChange.territories.before[territoryIdx].troops;
                this.changeTerritoryTroops(territoryIdx, newTroops);
                const playerId = stateChange.territories.before[territoryIdx].player_id;
                const newColor = this.gameState.players[playerId].color;
                this.changeTerritoryColor(territoryIdx, newColor);
            }
        }
    }

    public changeTerritoryTroops(territoryId: string | number, newTroops: number) {
        const territory = $('#territory-' + territoryId);
        const currentTroops = parseInt(territory.text());
        this.spawnTroopPopup(territoryId, newTroops - currentTroops);
        territory.text(newTroops);
    }

    public spawnTroopPopup(territoryId: string | number, amount: number) {
        const colorClass: string = (amount < 0)? 'negative' : 'positive';
        const container = $('#modal-container');
        const popup = $('<div class="troop-popup ' + colorClass + '">' + Math.abs(amount) + '</div>');
        container.append(popup);
        const terr = $('#territory-' + territoryId);
        popup.offset({
            top: terr.offset().top + .5 * terr.height() - 0.5 * popup.height(),
            left: terr.offset().left + .5 * terr.width() - 0.5 * popup.width()
        });
        popup.css('transform', 'translate(0, -50px)').fadeOut(3000, function() {$(this).remove();});
    }

    public changeTerritoryColor(territoryId: string | number, targetColor: number) {
        const territoryDiv =  $('#territory-' + territoryId).parent();
        territoryDiv.removeClass(function(index, className) {
            return (className.match (/(^|\s)tc-\S+/g) || []).join(' ');
        });
        territoryDiv.addClass('tc-' + targetColor.toString());
    }

    public driveForward() {
        let currentEvent: GameEvent;
        do {
            if (this.currentStep >= this.eventList.length) {
                return;
            }
            currentEvent = this.eventList[this.currentStep];
            this.applyStateChange(this.gameState, currentEvent.stateChange);
            this.applyStateChangeOnView(currentEvent.stateChange);
            this.currentStep++;
        } while (currentEvent.stateChange.isNotPlaybackBlocking);
    }

    public driveBackward() {
        let currentEvent: GameEvent;
        do {
            if (this.currentStep <= 0) {
                return;
            }
            this.currentStep--;
            currentEvent = this.eventList[this.currentStep];
            this.unapplyStateChange(this.gameState, currentEvent.stateChange);
            this.unapplyStateChangeOnView(currentEvent.stateChange);
        } while (currentEvent.stateChange.isNotPlaybackBlocking);
    }

    public startPlayback(
        intervalMillis: number,
        forwardDirection: boolean,
        stopCondition: () => boolean
    ) {
        this.stopPlaybackIfPlaying();
        this.playIntervalVariable = setInterval(() => {
            forwardDirection? this.driveForward() : this.driveBackward();
            if (stopCondition()) {
                this.stopPlaybackIfPlaying();
            }
        }, intervalMillis);
        $("#playback-play-pause-button").removeClass("fa-play").addClass("fa-pause");
    }

    public stopPlaybackIfPlaying(): boolean {
        if (this.playIntervalVariable) {
            clearInterval(this.playIntervalVariable);
            this.playIntervalVariable = null;
            $("#playback-play-pause-button").removeClass("fa-pause").addClass("fa-play");
            return true;
        }
        return false;
    }

    public togglePlayPause() {
        if (this.stopPlaybackIfPlaying()) {
        } else {
            this.startPlayback(1000, true, () => this.currentStep >= this.eventList.length);
        }
    }

    public driveToNextRound() {
        const thisRound: number = this.gameState.round;
        this.startPlayback(50, true,
            () => this.currentStep >= this.eventList.length || this.gameState.round > thisRound);
    }

    public driveToPreviousRound() {
        const thisRound: number = this.gameState.round;
        this.startPlayback(50, false,
            () => this.currentStep <= 0 || this.gameState.round < thisRound);
    }

    public driveToLastState() {
        this.startPlayback(10, true,
            () => this.currentStep >= this.eventList.length);
    }

    public driveToFirstState() {
        this.startPlayback(10, false,
            () => this.currentStep <= 0);
    }
}
